<script setup lang="ts">
import { ElIcon } from 'element-plus'
import { type Component } from 'vue'

interface Props {
  message: string
  icon?: Component
}

const props = defineProps<Props>()
</script>

<template>
  <div class="empty-state">
    <el-icon v-if="props.icon" class="empty-state-icon">
      <component :is="props.icon" />
    </el-icon>
    <p class="empty-state-message">{{ props.message }}</p>
  </div>
</template>

<style scoped>
.empty-state {
  text-align: center;
  color: var(--el-text-color-secondary);
  padding: 10px 20px;
}

.empty-state-message {
  margin: 0;
  font-size: 14px;
}

.empty-state-icon {
  font-size: 48px;
  color: var(--el-text-color-placeholder);
  margin-bottom: 16px;
}
</style>

